import { useCallback, useEffect, useState } from 'react';

const PDP_HELPER_KEY = 'pdp-helper';
const usePDPHelperActivation = () => {
  const [isPDPHelperActive, setIsPDPHelperActive] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(PDP_HELPER_KEY) === 'yes') {
      setIsPDPHelperActive(true);
    }
  }, []);

  const togglePDPHelper = useCallback(() => {
    if (isPDPHelperActive) {
      localStorage.setItem(PDP_HELPER_KEY, 'no');
      setIsPDPHelperActive(false);
    } else {
      localStorage.setItem(PDP_HELPER_KEY, 'yes');
      setIsPDPHelperActive(true);
    }
  }, [isPDPHelperActive]);

  return { isPDPHelperActive, togglePDPHelper };
};

export default usePDPHelperActivation;
